import * as React from 'react';

import { IYadoOrderItem, IResort, IItemsType, IYadoRoom, ICurrency } from './types';
import t from './locales';

import OrderItemView from './OrderItemView';
import OrderItemPriceView from './OrderItemPriceView';
import Price from '../Shared/Price';
import { getLocale } from '../utils/pathHelper';
import { formatDateWithDayOfWeek } from '../utils/dateHelper';

interface IProps {
  item: IYadoOrderItem;
  itemsType: IItemsType;
  handleChange: (event: React.ChangeEvent) => void;
  handleRemove: (evnet: React.MouseEvent) => void;
  index: number;
  resort?: IResort;
  localCurrency?: ICurrency;
}

const YadoOrderItem: React.FC<IProps> = ({ item, itemsType, handleChange, handleRemove, index, localCurrency }) => {
  const { checkInDate, checkOutDate, totalAmountIncludingTax, roomType, rooms, resort } = item;
  const locale: string = getLocale() || 'en';

  function renderRooms(rooms: IYadoRoom[], index: number) {
    return rooms.map((room: IYadoRoom, roomIndex: number) => (
      <p className="mute" key={`yado-order-item-${index}-room-${roomIndex}`}>
        {rooms.length > 1 && <strong>部屋{index + 1}</strong>}
        <span>{t.adultNum()} {room.males + room.females}</span>
        <span>{t.childNum()} {room.childAges.length}</span>
      </p>
    ));
  }

  return (
    <OrderItemView key={`order-item-${index}`}>
      <div>
        <p className="name">
          {item.yadoName} / {t.whichRoomType({ roomType })}
        </p>
        <p className="mute">{resort.resortName}</p>
        <p className="mute">
          {formatDateWithDayOfWeek(checkInDate)} - {formatDateWithDayOfWeek(checkOutDate)}
        </p>
        {renderRooms(rooms, index)}
        {/*<div className="number-select">
          <div>
            <p>{t.adultNum()}</p>
            <OrderItemNumberSelect
              selectedNumber={people.adultNum}
              handleChange={handleChange}
              itemsType={itemsType}
              propKey="adultNum"
              index={index} />
          </div>
          <div>
            <p>{t.childNum()}</p>
            <OrderItemNumberSelect
              selectedNumber={people.childNum}
              handleChange={handleChange}
              itemsType={itemsType}
              propKey="childNum"
              index={index} />
          </div>
        </div>*/}
      </div>
      <OrderItemPriceView>
        <div className='item-price'>
          <Price price={totalAmountIncludingTax} fontSize={14} localCurrency={localCurrency} />
          {locale !='ja' &&
            <a href="#" onClick={handleRemove} data-index={index} data-items-type={itemsType} className="trash">
              <i className="fas fa-trash" />
            </a>
          }
        </div>

        {locale =='ja' &&
          <a href="#" onClick={handleRemove} data-index={index} data-items-type={itemsType} className="remove-item">
            <i className="fas fa-trash" />
            カートから削除
          </a>
        }
      </OrderItemPriceView>
    </OrderItemView>
  );
}

export default YadoOrderItem;
